const Stat = ({ testid, label, value, accent }) => (
  <div className="rounded-2xl border border-ink/10 bg-surface px-5 py-4">
    <p className="text-[11px] font-semibold uppercase tracking-wider text-ink/45">{label}</p>
    <p data-testid={testid} className={`mt-1 text-2xl font-bold ${accent ? "text-mint" : "text-ink"}`}>
      {value}
    </p>
  </div>
);

export const StatsBar = ({ leads, statements }) => {
  const weekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const weekLeads = leads.filter((l) => new Date(l.created_at).getTime() >= weekAgo).length;
  const verified = leads.filter((l) => l.verified).length;
  const savings = statements.reduce((sum, s) => sum + (s.est_savings || 0), 0);
  return (
    <div data-testid="admin-stats" className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      <Stat testid="stat-total-leads" label="Total Leads" value={leads.length} />
      <Stat testid="stat-week-leads" label="Last 7 Days" value={weekLeads} accent />
      <Stat testid="stat-verified-leads" label="Verified Emails" value={verified} />
      <Stat testid="stat-statements" label="Statements" value={statements.length} />
      <Stat
        testid="stat-savings"
        label="Est. Savings Found"
        value={`$${savings.toLocaleString("en-US")}/mo`}
        accent
      />
    </div>
  );
};
